"use client";

import { Headphones } from "lucide-react";
import { useState } from "react";
import { PageHeader } from "@/components/ui/page-header";
import { Sheet } from "@/components/ui/sheet";
import type { ProductLine } from "@/content/types";

export function ProductPageHeader({
  title,
  line,
}: {
  title: string;
  line?: ProductLine;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <PageHeader
        title={title}
        fallbackHref="/"
        className={line === "hirudin" ? "bg-hirudin-bg/45" : undefined}
        rightAction={
          <button
            type="button"
            aria-label="联系客服"
            onClick={() => setOpen(true)}
            className="flex size-11 items-center justify-center text-ink focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-forest-500"
          >
            <Headphones className="size-5 stroke-[1.5]" aria-hidden="true" />
          </button>
        }
      />
      <Sheet open={open} onOpenChange={setOpen} title="咨询客服">
        <div className="space-y-3 text-sm leading-[1.7] text-ink-2">
          <p>客服渠道接入中，请先通过页面底部联系方式咨询。</p>
          <p>售前与售后信息以客服实际回复为准。</p>
        </div>
      </Sheet>
    </>
  );
}
